export const februaryAbbreviatedLowercase = "Zqa";
export default {februaryAbbreviatedLowercase};